import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getStyle } from '../../utils/utils';
import PurchaseInvoiceList from './ChainInvoicingComponents/PurchaseInvoiceList';
import ConsolidatedInvoiceList from './ChainInvoicingComponents/ConsolidatedInvoiceList';
import {
  fetchChainMemberships as _fetchChainMemberships,
  fetchChainCareServices as _fetchChainCareServices,
} from '../../actions/chainActions';

class ChainInvoicingView extends React.Component {
  state = {
    activeTab: 'purchase',
    openConsolidatedId: null,
  };

  componentWillMount() {
    var chainId = this.props.chainId || this.props.selectedChainId;
    if (chainId) {
      this.props.fetchChainMemberships(chainId);
      this.props.fetchChainCareServices(chainId);
    }
  }

  componentDidUpdate(prevProps) {
    var chainId = this.props.chainId || this.props.selectedChainId;
    var prevChainId = prevProps.chainId || prevProps.selectedChainId;
    if (chainId && chainId !== prevChainId) {
      this.props.fetchChainMemberships(chainId);
      this.props.fetchChainCareServices(chainId);
    }
  }

  render() {
    var t = this.props.t;
    var chainId = this.props.chainId || this.props.selectedChainId;
    var chainMemberships = this.props.chainMemberships;
    var chainCareServices = this.props.chainCareServices;
    var activeTab = this.state.activeTab;
    var blockExternalWrites = this.props.blockExternalWrites;

    return (
      <CBMediaQuery>
        {function (screenSize) {
          return (
            <div style={getStyle(screenSize, styles, 'container')}>
              {blockExternalWrites && (
                <div style={styles.default.pilotBanner}>
                  {t('pilotModeNoExport')}
                </div>
              )}
              <div style={getStyle(screenSize, styles, 'tabBar')}>
                <button
                  style={{
                    ...styles.default.tabButton,
                    ...(activeTab === 'purchase' ? styles.default.tabButtonActive : {}),
                  }}
                  onClick={function () { this.setState({ activeTab: 'purchase' }); }.bind(this)}
                >
                  {t('purchaseInvoices')}
                </button>
                <button
                  style={{
                    ...styles.default.tabButton,
                    ...(activeTab === 'consolidated' ? styles.default.tabButtonActive : {}),
                  }}
                  onClick={function () { this.setState({ activeTab: 'consolidated' }); }.bind(this)}
                >
                  {t('consolidatedInvoices')}
                </button>
              </div>

              {activeTab === 'purchase' && (
                <PurchaseInvoiceList
                  chainId={chainId}
                  chainMemberships={chainMemberships}
                  onOpenConsolidated={function (consolidatedId) {
                    this.setState({ activeTab: 'consolidated', openConsolidatedId: consolidatedId });
                  }.bind(this)}
                />
              )}

              {activeTab === 'consolidated' && (
                <ConsolidatedInvoiceList
                  chainId={chainId}
                  chainCareServices={chainCareServices}
                  openConsolidatedId={this.state.openConsolidatedId}
                  onClearOpenConsolidated={function () {
                    this.setState({ openConsolidatedId: null });
                  }.bind(this)}
                />
              )}
            </div>
          );
        }.bind(this)}
      </CBMediaQuery>
    );
  }
}

var styles = {
  default: {
    container: {
      width: '100%',
      padding: '0px 16px 0px 0px',
    },
    pilotBanner: {
      backgroundColor: 'rgba(255, 213, 79, 0.15)',
      border: '1px solid rgba(255, 213, 79, 0.4)',
      borderRadius: 8,
      padding: '10px 16px',
      margin: '16px 16px 0 16px',
      color: '#FFE082',
      fontSize: 13,
    },
    tabBar: {
      display: 'flex',
      gap: 0,
      padding: '16px 16px 0 16px',
    },
    tabButton: {
      padding: '10px 24px',
      fontSize: 14,
      fontWeight: 600,
      color: 'rgba(255, 255, 255, 0.6)',
      backgroundColor: 'transparent',
      border: 'none',
      borderBottom: '2px solid transparent',
      cursor: 'pointer',
      transition: 'color 0.2s, border-color 0.2s',
    },
    tabButtonActive: {
      color: '#fff',
      borderBottomColor: '#fff',
    },
  },
  small: {
    container: {
      padding: 0,
    },
  },
};

function mapStateToProps(state) {
  var selectedChainId = state.chain.selectedChainId;
  var user = state.authUser.user;
  var userChains = user && user.chains ? user.chains : [];
  var currentChain = userChains.find(function (c) { return c.id === selectedChainId; });
  return {
    selectedChainId: selectedChainId,
    chainMemberships: state.chain.chainMemberships,
    chainCareServices: state.chain.chainCareServices,
    blockExternalWrites: currentChain ? !!currentChain.block_external_writes : false,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchChainMemberships: _fetchChainMemberships,
    fetchChainCareServices: _fetchChainCareServices,
  },
)(translate('ChainInvoicingView')(ChainInvoicingView));
